export const useSxStyles = () => {
  return {
    refDiv: {
      display: 'flex',
      flexGrow: 1,
    },
  };
};
